import { Observable } from 'rxjs';
import _ from 'lodash';

import { USStates } from './USStates';

export const US_UNINCORPORATED_TERRITORIES = ['PR', 'VI', 'GU', 'MP', 'AS'];

const geocodeByAddress = (address) => {
  const geocoder = new window.google.maps.Geocoder();
  const { OK } = window.google.maps.GeocoderStatus;

  return new Promise((resolve, reject) => {
    geocoder.geocode({ address }, (results, status) => {
      if (status !== OK) {
        reject(status);
      } else {
        resolve(results);
      }
    });
  });
};

export default (address) =>
  Observable.fromPromise(geocodeByAddress(address)).map((results) => {
    // eslint-disable-next-line camelcase
    const res = results.shift();

    const { formatted_address, address_components, geometry } = res;

    // eslint-disable-next-line camelcase
    const addressComponents = _.keyBy(address_components, (component) =>
      _.without(component.types, 'political', 'establishment').shift()
    );

    // eslint-disable-next-line camelcase
    const splitAddress = formatted_address.split(',');

    let country = addressComponents.country?.long_name;
    let countryCode = addressComponents.country?.short_name;
    let state = addressComponents.administrative_area_level_1?.long_name;
    let stateCode = addressComponents.administrative_area_level_1?.short_name;
    if (US_UNINCORPORATED_TERRITORIES.includes(countryCode)) {
      stateCode = countryCode;
      state = USStates[stateCode];
      countryCode = 'US';
      country = 'United States';
    }

    const location = {
      coordinates: [geometry.location.lng(), geometry.location.lat()],
      type: 'Point',
    };

    const locationObject = {
      address:
        addressComponents.street_number && addressComponents.route
          ? `${addressComponents.street_number.short_name} ${addressComponents.route.short_name}`
          : splitAddress[splitAddress.length > 4 ? 1 : 0],
      area: (
        addressComponents.neighborhood ||
        addressComponents.sublocality ||
        addressComponents.locality ||
        addressComponents.administrative_area_level_3 ||
        addressComponents.administrative_area_level_2 ||
        {}
      ).long_name,
      city: (
        addressComponents.locality ||
        addressComponents.sublocality ||
        addressComponents.administrative_area_level_3 ||
        addressComponents.administrative_area_level_2 ||
        addressComponents.neighborhood ||
        {}
      ).long_name,
      state,
      stateCode,
      postalCode: addressComponents.postal_code?.short_name,
      country,
      countryCode,
      geo: location,
    };

    const meta = {
      placeId: res.place_id,
      googleMapsUrl: `https://www.google.com/maps/place/?q=place_id:${res.place_id}`,
    };

    return { locationObject, location, meta };
  });
